import React from 'react';
import { flagToBool } from 'pano-utils';
import useLangString from '@hooks/useLangString';
import { $tourData } from '@stores/dataStores';
import { $editingFirstSceneButton } from '@stores/editingStores';
import useEditingStore from '@hooks/useEditingStore';
import useTemplateFeature from '@hooks/useTemplateFeature';

export function WFirstSceneButton() {
  const hasFeature = !!useTemplateFeature('globalFlagsSettings')
    .backToFirstScene;
  const firstSceneButton = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.config?.firstSceneButton,
    $editing: $editingFirstSceneButton.store,
  });
  const enabled = hasFeature && flagToBool(firstSceneButton?.enabled ?? 0);
  const lang = useLangString(
    {
      btn: [
        firstSceneButton?.label && firstSceneButton?.label.length > 0
          ? firstSceneButton?.label
          : '返回',
        firstSceneButton?.label && firstSceneButton?.label.length > 0
          ? firstSceneButton?.label
          : 'Home',
      ],
    },
    [firstSceneButton?.label]
  );

  return enabled ? (
    <div>
      <div
        className="mt-15 inline-flex h-30 select-none items-center justify-center rounded px-10"
        style={{
          color: `rgba(${firstSceneButton?.fontColor ?? '255,255,255,1'})`,
          backgroundColor: `rgba(${firstSceneButton?.bgColor ?? '0,0,0,1'})`,
        }}
      >
        <div>{lang.btn}</div>
      </div>
    </div>
  ) : null;
}
